import { CommonsEnvironment } from '@infodata-group/inf-commons';

export const environment: CommonsEnvironment = {
  production: true,
  env: 'preprod',

  api: {
    apiEndPoint: '/api/',
    settingsApi: 'auth/settings',
  },
  app: {
    appName: 'Webtools',
    appVersion: '3.4.0',
    appVersionDate: '28/10/2026',
    defaultRoute: '',
    appId: 'e7a900be-7de6-4397-83b0-d3b47ed4145d',
    cache: 0,
  },
  auth: {
    loginUrl: 'api/auth/auth-default',
    logoutUrl: 'api/auth/logout',
    initApi: null,
    azure: {
      tenant: 'o365.infodata.lu',
      client: '1ab0c7d0-9cba-4569-ab50-cea719fc647c',
      redirectUri: 'https://preprod-webtools.integrix.lu/oauth2',
      api: 'auth/auth-azure',
    },
  },
  login: {
    loginRoute: 'login',
    resetRequest: 'auth/reset-request',
    resetPassword: 'auth/reset-password',
    defaultConnection: true,
  },
  portal: {
    api: 'auth/auth-portal',
    portalUri: 'https://preprod-portail.integrix.lu',
    userAppsApi: 'auth/portail-apps',
    loadPortalApps: true,
    imagesUri: 'https://portail.integrix.lu/notifications-email/visu/',
  },
  ui: {
    appLogoPath: 'https://assets.integrix.lu/img/logos/integrix-webtools.png',
    companyLogoPath: 'https://assets.integrix.lu/img/logos/infodata.svg',
    lockerBackgroundPath:
      'https://assets.integrix.lu/img/backgrounds/2025.webp',
  },
  changelog: {
    enable: true,
    endpoint:
      'https://changelogs.integrix.lu/api/versions?&WITH=product|=|WEBTOOLS-WEB',
    route: 'changelog',
  },
};
